import React from "react";

const Footer = () => {
  return (
    <div className="bg-gray-300 text-gray-500">
      <h1 className="text-2xl p-4 font-medium text-center">MANOJTOUR</h1>
    </div>
  );
};

export default Footer;
